<template>
  <div class="col-xl-12">
    <div class="appointment">
      <div class="card">
        <div class="card-header card-no-border">
          <div class="header-top">
            <h5 class="m-0">DEALER VISITS</h5>
            <span class="current-month">{{ currentYearAndMonth.toUpperCase() }}</span>
          </div>
        </div>
        <div class="card-body" :class="loading ? 'loading-center' : 'pt-0'">
          <div class="appointment-table table-responsive">
            <!-- Loading spinner -->
            <div v-if="loading" class="spinner-container">
              <div class="spinner"></div> <!-- Circular Spinner -->
            </div>

            <!-- Error Message -->
            <div v-if="error" class="error-container">
              <img src="../../../../assets/vectors/data_not_found.png" alt="Error" class="error-image" />
              <p class="error-message">{{ error }}</p>
            </div>

            <!-- Table Data -->
            <table v-if="!loading && !error" class="table table-bordernone">
              <tbody>
              <tr v-for="(item, index) in dealerVisits" :key="item.dealerVisitId">
                <td>
                  <div class="avatar rounded-circle me-2" :style="{ backgroundColor: '#8B7E74', color: '#fff' }">
                    <span>{{ getInitials(item.dealerName) }}</span>
                  </div>
                </td>
                <td class="img-content-box">
                  <h6 class="f-14 mb-0">{{ item.dealerName }}</h6>
                  <p class="text-muted f-12">{{ formatDateTime(item.createdDateTime) }}</p>
                </td>
                <td class="text-end">
                  <p class="m-0 text-black">{{ item.visitedBy }}</p>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
            <a
                v-if="!loading && !error"
                class="see-more"
                :href="$router.resolve({ path: '/dealer-visit-report' }).href"
                target="_blank"
            >
              See More
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fetchDealerVisits} from '@/services/dataService';

export default {
  data() {
    return {
      //Get the API access token from the local storage
      token: localStorage.getItem('token_set'),

      //Get the user profile id from the local storage
      profileId: localStorage.getItem('profile_id'),

      dealerVisits: [],
      loading: false,   // Loading state
      error: null,      // Error state
      currentYearAndMonth: this.getCurrentYearAndMonth(),
    };
  },

  mounted() {
    this.fetchDealerVisits();
  },

  methods: {
    // Method to get the initials from the distributor name
    getInitials(name) {
      const names = name.split(" ");
      const firstInitial = names[0] ? names[0][0].toUpperCase() : "";
      const lastInitial = names[1] ? names[1][0].toUpperCase() : "";
      return `${firstInitial}${lastInitial}`;
    },

    // Get the current year and month
    getCurrentYearAndMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString('default', { month: 'long' });
      return `${year} ${month}`;
    },

    //Format DateTime as "YYYY-MM-DD | HH:MM:SS AM/PM"
    formatDateTime(dateTime) {
      if (!dateTime) return "N/A"; // Handle empty values

      const date = new Date(dateTime);
      if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid dates

      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const timeOptions = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true };

      const formattedDate = date.toLocaleDateString("en-CA", options).replace(/\//g, "-"); // Ensures YYYY-MM-DD
      const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

      return `${formattedDate} | ${formattedTime}`;
    },

    //Fetch dealer_visit Visits from the API
    async fetchDealerVisits () {
      try {
        this.loading = true;

        const response = await fetchDealerVisits(this.profileId, this.token);

        if(response.data.success === true) {
          this.dealerVisits = response.data.data.map(dealerVisit => ({
            dealerName: dealerVisit.business_name,
            createdDateTime: dealerVisit.created_at,
            visitedBy: dealerVisit.first_name || "N/A",
          }));
        } else {
          this.error = response.data.message;
        }
      } catch (e) {
        this.error = "Something went wrong";
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.current-month {
  color: #5A6166;
}

/* Spinner container styling */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a height to vertically center the spinner */
}

/* Spinner styling */
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-top: 4px solid #8B7E74; /* Spinner color (green theme) */
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

/* Animation for the spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Centering the spinner when loading */
.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px; /* Optional fixed height */
}

/* Avatar styling */
.avatar {
  width: 40px; /* Set width of avatar */
  height: 40px; /* Set height of avatar */
  display: flex; /* Enable flexbox for centering */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  font-size: 18px; /* Font size for initials */
  font-weight: lighter; /* Light font weight */
  border-radius: 50%; /* Makes the avatar circular */
  text-transform: uppercase; /* Uppercase for initials */
}

.see-more {
  color: #8B7E74;
  font-weight: bold;
}

.see-more:hover {
  cursor: pointer;
  font-weight: bold;
  color: #5A6166;
}

/* Center content inside the table row */
.error-container {
  text-align: center;
}

/* Results not found image */
.error-image {
  max-width: 200px;
  display: block;
  margin: 0 auto;
}

/* Results not found message */
.error-message {
  font-size: 15px;
  font-weight: bold;
  color: #8B7E74;
  padding-top: 10px;
}
</style>
